import {
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Grid,
  Box,
  Dialog,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks";
import { useState, useEffect } from "react";
import Icon_printer from "../../../../../../assets/Icon_printer.svg";
import closeIcon from "../../../../../../assets/icon-xout-black.svg";
import { getquickBillPayPageContent } from "../../../../../../SharedContextStore/slices/contents/qbpContentAem";
import { format as dateFormat } from "date-fns";
import { useCustomNavigate } from "../../../../../../Utils/navigationUtils";
import { QuickBillPay } from "../../../../../../SharedComponents/contents";
import { nonAuthenticQBPGTM, authenticQbpGTM } from "../../../../../../Utils/googleTags";
import useBrightspeedHeaders from "../../../../../../hooks/useBrightspeedHeader";
import useBrightspeedUser from "../../../../../../hooks/useUser";
import { setGTM_TagTriggerFor } from "../../../../../../SharedContextStore/slices/brightSpeedUserUtils";

export const ConfirmationPage = (props: any) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.data);
  const { serviceDetails: servicePlan} = useAppSelector((state) => state.serviceDetails);
  const CreditCardDetails = useAppSelector(
    (state) => state.paymentMethods.autoPaymentMethods
  );
  const UserSessionDetails = useAppSelector((state) => state.user.data);
  const BankDetailsCard = useAppSelector(
    (state) => state.paymentMethods.autoPaymentMethods
  );
  const { customNavigate } = useCustomNavigate();
  const quickBillPay: any = QuickBillPay();
  const QBP_CONTENT_2 = quickBillPay;
  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );


  const navigation = useNavigate();
  const onCloseErrorModal = () => {
    if (closeErrorModal) {
      setCloseErrorModal(false);
      navigation("/my-bills/view-payments");
    }
  };
  const [bankCard, setBankCardDetails] = useState<any>([]);
  const [creditCard, setCreditCardDetails] = useState<any>([]);
  const [hideCreditCardFields, setHideCreditField] = useState<boolean>(true);
  const [closeErrorModal, setCloseErrorModal] = useState(true);
  const [showOneTimePay, setOneTimePay] = useState<boolean>(false);
  const [informationCard, setInformationCard] = useState<any>(
    props.cardInformation
  );
  const [currentAmount, setCurrentAmount] = useState<any>({
    totalAmount: props.amount,
    billPaymentAmount: props.billPayment,
  });
  const [billPaymentAmount, setBillPaymentAmount] = useState<any>(
    props.billPayment
  );
  const headers = useBrightspeedHeaders();

  const { 
    can_GTM_Tag_Trigger, 
    GTM_Tag_Triggered_For,
    accountType,
    accountStatus,
    accountTenure, 
    isUserHaveAutoPay,
    isUserHavePaperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    userCurrentInternet_plan_speed,
    voice,
    userStateCode,
    userWire_center, 
  } = useBrightspeedUser();

  useEffect(() => {
    if(
      props.isUnAuthQbp && can_GTM_Tag_Trigger && GTM_Tag_Triggered_For !== user?.billingAccountNumber && servicePlan
    ) {
      nonAuthenticQBPGTM({
        companyName: headers?.siteId?.toLowerCase() || "", 
        accountType, 
        accountTenure, 
        accountStatus, 
        autoPay: isUserHaveAutoPay, 
        paperlessBilling: isUserHavePaperlessBilling, 
        currentAmountDue,
        billDueDate,
        lastInvoiceAmount, 
        lastBillDate, 
        internet_plan_speed: userCurrentInternet_plan_speed, 
        stateCode: userStateCode, 
        wireCenter: userWire_center, 
        voice,
        flowType: 'Non authentic qbp success'
      });
        
      dispatch(setGTM_TagTriggerFor(user?.billingAccountNumber));
    }
  }, [can_GTM_Tag_Trigger, user, servicePlan]);

  useEffect(() => {
    if(!props.isUnAuthQbp && can_GTM_Tag_Trigger){
      authenticQbpGTM({
        flowType: "Authentic qbp flow success", 
        companyName: headers?.siteId?.toLowerCase() || ""
      })
      
      dispatch(setGTM_TagTriggerFor(user?.billingAccountNumber));
    }
  }, [can_GTM_Tag_Trigger, user]);

  useEffect(() => {
    if(!QBP_CONTENT_Data) {
    dispatch(getquickBillPayPageContent());
    }
  }, []);

  useEffect(() => {
    if (props.selectedPaymentCard === "Bank Account") {
      setHideCreditField(false);
      setOneTimePay(true);
    } else if (props.selectedPaymentCard === "Credit / Debit Card") {
      setHideCreditField(true);
      setOneTimePay(true);
    }
    setCreditCardDetails(CreditCardDetails);
    setBankCardDetails(BankDetailsCard);
  }, [CreditCardDetails, BankDetailsCard]);
  const handlePrint = () => {
    window.print();
  };
  return (
    <Dialog open={closeErrorModal}
      onClose={(event, reason: any) => {
        if (reason === 'backdropClick') {
          return;
        }onCloseErrorModal()
      }}
      maxWidth={"lg"} className="addPaymentNew confirmation-modal" scroll='body'   
      // aria-describedby="Payment-dialog-description"
      aria-labelledby="Payment-dialog-title"
      aria-modal="true">
      <Container className={`generalContainer ${props.isUnAuthQbp ? "": "qbp-auth-conf-modal"}`} >
        <Box className="ConfirmationPage">
          <Stack spacing={1} className="GeneralPageReceive">
            <Typography className="GeneralTitle" component="h2" id="Payment-dialog-title">
              {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.general_title}
            </Typography>
            
            <Typography className="CustomerTitle"  component="h2">
              {UserSessionDetails.firstName} {UserSessionDetails.lastName}
            </Typography>

            <Typography className="ConfirmationNumberTitle" variant="body1" color="initial" align="left">
              {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.descriptions?.confirmation_payment_2 + " "}
              Confirmation number {props.qbpSuccessCode}.
            </Typography>

            <Typography className="emailConfirmationTitle" variant="body1" color="initial" align="left">
              {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.descriptions?.confirmation_email + " "}
              <b>{UserSessionDetails.email} </b>
              {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.descriptions?.recieptnote}
            </Typography>

            <Typography className="paymentDetailsTitle" variant="body1" color="initial" component="h3">
              {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.payment_details_titles
                ?.payment_details_title + " "}
            </Typography>

            <Divider role="presentation" />

            <Box sx={{display:"flex"}} className="AmountsInformation">
              <Box>
                {props.isUnAuthQbp && <Typography variant="subtitle1" color="initial" className="heading mt-4 pb-2" 
                sx={{lineHeight: "24px"}}>
                  {
                    <>
                      <span className="font-primary">{QBP_CONTENT_2?.entry.qbp_flow?.review_payment_details?.onetime_payment_title}</span>
                      <strong>{` ****${UserSessionDetails?.billingAccountNumber?.slice(-4)}`}</strong>
                    </> 
                  }
                </Typography>}
                <Table className="p-0 confimation-table"> 
                  <caption style={{ opacity: "0", position: "absolute" }} className="p-0">
                    {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.payment_details_titles
                      ?.payment_details_title + " "}</caption>                 
                <TableBody>
                  <TableRow>
                  <TableCell className="p-0 border-0" style={{width:"50%"}}>
                    <Typography
                        className="list-item key labelsContainer"                        
                      >
                        {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.payment_date_label}
                      </Typography>
                      </TableCell>
                      <TableCell className="p-0 border-0">
                      <Typography className="list-item value labelsContainer">
                        {dateFormat(new Date(), "M/d/yyyy")} 
                      </Typography>
                      </TableCell>
                  </TableRow>
                  <TableRow>
                  <TableCell className="p-0 border-0">
                 
                    <Typography                     
                      className="list-item key labelsContainer"
                    >
                       {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.payment_method_label}
                      </Typography>
                    </TableCell>
                    <TableCell className="p-0 border-0">
                    <Typography
                      className="list-item value labelsContainer"
                    >
                      {
                        informationCard?.bankAccountNumber && `${informationCard.type} **** ${informationCard.bankAccountNumber.slice(-4)}` 
                        || informationCard?.cardNumber && `${informationCard.creditCardType?.toLowerCase() || informationCard.type?.toLowerCase()} **** ${informationCard.cardNumber.slice(12)}`
                      }
                    </Typography>                 
                   </TableCell>
                    </TableRow> 
                  {hideCreditCardFields 
                   &&
                    <TableRow>
                  <TableCell className="p-0 border-0">
                        <Typography                          
                          className="list-item key labelsContainer"
                        >
                          {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.bill_payment_label}
                          </Typography>
                        </TableCell>
                        <TableCell className="p-0 border-0">
                        <Typography
                          style={{ textAlign: "end" }}                         
                          className="list-item value labelsContainer" >
                             {currentAmount.billPaymentAmount ? `$${currentAmount.billPaymentAmount}` : '$0.00'}
                          </Typography>
                      </TableCell>
                      </TableRow>
                  }
                  {hideCreditCardFields ? (
                    <>
                       <TableRow>
                        <TableCell className="p-0 border-0">
                        <Typography                         
                          className="list-item key labelsContainer"
                        >
                           {"Payment processing fee"}
                          </Typography>
                        </TableCell>
                        <TableCell className="p-0 border-0">
                        <Typography className="list-item value labelsContainer">
                          {"$3.50"}
                          </Typography>
                      </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    ""
                  )}
                  <TableRow>
                  <TableCell className="p-0 border-0">
                      <Typography variant="body1" color="initial" className="totalAmountCharged labelsContainer">
                          {informationCard?.bankAccountNumber ?
                          `${QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.amount_charged.slice(0, -1)}:`
                          :
                          `${QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.amount_charged}`
                          }
                        </Typography>
                    </TableCell>
                    <TableCell className="p-0 border-0">
                    <Typography variant="body1" color="initial" className="totalAmountCharged labelsContainer">
                          {`$${currentAmount.totalAmount}`}
                      </Typography> 
                    </TableCell>
                  </TableRow>
                  </TableBody>
                  </Table>
                 
                  <Typography className="labelsContainer customerNoteInfo">                   
                    {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.additional_information?.payment_posting_information}
                  </Typography>
                  
                  <Box display="flex" className="printLinkGrid">
                    <Box>
                      <img
                        src={Icon_printer}
                        onClick={() => {
                          handlePrint();
                        }}
                        alt="Print receipt icon"
                      ></img>
                    </Box>
                    <Box sx={{marginLeft : "8px"}}>
                      <Button disableRipple
                        className="linkPrintInvoice p-0" 
                        sx={{ textTransform: "none", background: "none" }}
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print receipt
                      </Button>
                    </Box>
                  </Box>
                  <Typography variant="body1" color="initial" sx={{ marginLeft: 1 }} className="aditionalInfoTitle font-primary" component="h3">
                    {" "}
                    {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.additional_information?.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ marginLeft: 1 }}
                    className="descriptionAdditionalInfo1"
                  >
                    {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.additional_information?.description1}
                  </Typography>
               
              </Box>
            </Box>
          </Stack>
        </Box>
      </Container>
      {props.isUnAuthQbp 
      ? <Container className="BoxViewPaymentButton">
          <Button
            variant="outlined" 
            className="cancel-button"
            onClick={() => customNavigate("/non-auth-quick-bill-pay")}
          >
            {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.confirm_buttons?.cta_close}
          </Button>
          <Button
            className="continue-button"
            variant="contained"
            color="primary"
            onClick={() => customNavigate("/login")}
          >
            {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.confirm_buttons?.cta_signin}
          </Button>
        </Container>
      : <Container className="BoxViewPaymentButton">
        <Button
          className="btnClose"
          variant="contained"
          color="primary"
          onClick={() => navigation("/my-bills/view-payments")}
        >
          {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.confirm_buttons?.cta_close}
        </Button>
      </Container>}
      <Stack className="closeIcon" direction="row" justifyContent="end">
        <Typography component="button" className="buttonText" onClick={onCloseErrorModal} aria-label="Close the dialog">
        <img src={closeIcon} alt="Close the dialog" className="cursor-pointer" />
        </Typography>
      </Stack>
    </Dialog>
  );
};
